import { createTheme } from "@mui-wrapper";
import { flatUiThemeOptions } from "@flat-ui";

/**
 * Overrides the default Mui theme
 */
export const mainTheme = createTheme({
  ...flatUiThemeOptions,
  // flat-ui's typography, font family included, with only the caption tint on top: `typography`
  // is not merged either, and restating the font family here would reach every flat-ui text style.
  typography: {
    ...flatUiThemeOptions.typography,
    caption: {
      // The palette is not reachable while the theme is built, so read the CSS variable that
      // `cssVariables` emits for `text.secondary`, which follows the colour scheme.
      color: "var(--mui-palette-text-secondary)",
    },
  },
});
